import React, { useEffect, useState } from 'react';
import { Modal, TextField } from '@gerdau/hefesto';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ERoutes } from '../../../../../../../routes';
import { ApplicationState } from '../../../../../../../store';
import { saveMockup } from '../../../../../../../store/ducks/fabrication-mockups/actions';
import { IFabricationMockup } from '../../../../../../../store/ducks/fabrication-mockups/types';
import { sendTagging } from '../../../../../../../store/ducks/tagging/actions';
import { EProjectsMockupsRoutes } from '../../../../../projectsMockup.routes';
import { DuplicateMockupModalContainer } from './styles';

interface DuplicateMockupProps {
  contractNumber: string;
  mockup: IFabricationMockup;
  listOfMockupsNames: string[];
  onCancel: () => void;
}

const DuplicateMockup: React.FC<DuplicateMockupProps> = ({
  contractNumber,
  mockup,
  listOfMockupsNames,
  onCancel
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const saveMockupState = useSelector(
    (appState: ApplicationState) => appState.fabricationMockups.saveMockupState
  );

  const [mockupName, setMockupName] = useState('');

  const duplicatedMockup = () => {
    dispatch(
      saveMockup(
        contractNumber,
        mockupName,
        mockup.hasRoof,
        mockup.hasCovering,
        mockup.typicalFloorPlan,
        mockup.otherTypicalFloorPlan,
        mockup.pavements,
        undefined,
        {
          origem: 'duplicada',
          idMaqueteOrigem: `${contractNumber}_${mockup.name}`
        }
      )
    );
  };

  useEffect(() => {
    if (!saveMockupState?.loading && !!mockup.id && saveMockupState?.success) {
      history.push(
        `${ERoutes.PROJECT_MOCKUP}${EProjectsMockupsRoutes.MOCKUP_VIEW}`
      );
    }
  }, [saveMockupState?.loading, mockup.id, saveMockupState?.success, history]);

  return (
    <Modal
      onClose={onCancel}
      modalSize="lg"
      title={'Insira o nome para a maquete'}
      buttons={{
        left: {
          children: 'Cancelar',
          name: 'Cancelar',
          onClick: () => {
            dispatch(
              sendTagging({
                event: 'click',
                itemName: 'button:cancelar',
                itemDescription: `maquetesEProjetos_selecaoContratoDaObra_ModalDuplicar_cancelar`,
                screenName: 'LG:MaquetesEProjetos:Maquetes:ModalDuplicar'
              })
            );
            onCancel();
          },
          type: 'button',
          disabled: saveMockupState?.loading
        },
        right: {
          children: 'Duplicar maquete',
          name: 'Duplicar maquete',
          onClick: () => {
            dispatch(
              sendTagging({
                event: 'click',
                itemName: 'button:duplicarMaquete',
                itemDescription: `maquetesEProjetos_selecaoContratoDaObra_ModalDuplicar_duplicarMaquete`,
                screenName:
                  'LG:MaquetesEProjetos:SelecaoContratoDaObra:ModalDuplicar'
              })
            );
            duplicatedMockup();
          },
          type: 'button',
          disabled:
            listOfMockupsNames.includes(mockupName) || mockupName === '',
          loading: saveMockupState?.loading
        }
      }}
    >
      <DuplicateMockupModalContainer>
        Informe um nome para a nova maquete. O nome deve ser único.
        <TextField
          label="Nome da maquete"
          name="Nome da maquete"
          value={mockupName}
          onChange={(e) => setMockupName(e.target.value)}
          placeholder="Escreva o nome da maquete"
        />
      </DuplicateMockupModalContainer>
    </Modal>
  );
};

export default DuplicateMockup;
